import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { CompanyEntityIndex } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { AddressField } from '../../Fields';

interface BusinessAddressProps extends CompanyEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const BusinessAddress = (props: BusinessAddressProps) => {
  const { companyIndex, ...rest } = props;

  return (
    <AddressField
      {...rest}
      label="Business address"
      name={FIELD_PATHS.COMPANY_ADDRESS_FORMATTED(companyIndex)}
      path={FIELD_PATHS.COMPANY_ADDRESS(companyIndex)}
      className={PII_FIELD_MASKING_CLASS}
      onException={(e) => datadogUtil.addError(e)}
    />
  );
};
